import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import AdminPage from '@pages/admin/AdminPage';
import UserEditPage from '@pages/admin/UserEditPage';
import NotFoundPage from '@pages/error/NotFoundPage';

export const AdminRoutes = () => {
    return (
        <Routes>
            <Route path="/" element={<Navigate to="/admin/user-management" replace />} />
            <Route path="/user-management" element={<AdminPage />} />
            <Route path="/users/:id/edit" element={<UserEditPage />} />
            <Route path="/example-icons" element={<AdminPage />} />
            <Route path="/settings" element={<div>Admin Settings (To be implemented)</div>} />
            <Route path="/logs" element={<div>System Logs (To be implemented)</div>} />
            <Route path="*" element={<NotFoundPage />} />
        </Routes>
    );
};

export default AdminRoutes;